import isEqual from 'fast-deep-equal';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn } from 'zustand/traditional';

import { DashboardTabs } from 'types/pages/audience-builder/dashboard';
import {
  AudienceBuilderDashboardState,
  IAudienceBuilderDashboardActions,
  IAudienceBuilderDashboardState,
} from 'types/pages/audience-builder/dashboard/store';

const action = (name: keyof IAudienceBuilderDashboardActions) => ({ type: `audience-dashboard/${name}` });

const initialState: IAudienceBuilderDashboardState = {
  activateAudience: false,
  audienceParameters: {
    [DashboardTabs.Active]: { sort: [{ direction: 'desc', field: 'CreatedDate' }] },
    [DashboardTabs.Archived]: { sort: [{ direction: 'desc', field: 'CreatedDate' }] },
    [DashboardTabs.MasterFile]: { sort: [{ direction: 'desc', field: 'CreatedDate' }] },
    [DashboardTabs.PreBuilt]: { sort: [{ direction: 'desc', field: 'CreatedDate' }] },
  },
  filterIsOpen: false,
  isOpen: false,
  showArchiveAudience: false,
  showDeleteAudience: false,
  showDeleteShop: false,
  showUnarchiveAudience: false,
  tab: DashboardTabs.Active,
};

export const useDashboardStore = createWithEqualityFn<AudienceBuilderDashboardState>()(
  immer(
    devtools((set, _) => ({
      ...initialState,
      reset: () =>
        set(
          () => ({
            activateAudience: false,
            showArchiveAudience: false,
            showDeleteAudiences: false,
            showDeleteShop: false,
            tab: DashboardTabs.Active,
          }),
          false,
          action('reset')
        ),
      setActivateAudience: (value) => set({ activateAudience: value }, false, action('setActivateAudience')),
      setAudience: (value) => set({ audience: value }, false, action('setAudience')),
      setAudienceParameters: (value) => set({ audienceParameters: value }, false, action('setAudienceParameters')),
      setFilterIsOpen: (value) => set({ filterIsOpen: value }, false, action('setFilterIsOpen')),
      setIsOpen: (value) => set({ isOpen: value }, false, action('setIsOpen')),
      setShop: (value) => set({ shop: value }, false, action('setShop')),
      setShowArchiveAudience: (value) => set({ showArchiveAudience: value }, false, action('setShowArchiveAudience')),
      setShowDeleteAudience: (value) => set({ showDeleteAudience: value }, false, action('setShowDeleteAudience')),
      setShowDeleteShop: (value) => set({ showDeleteShop: value }, false, action('setShowDeleteShop')),
      setShowUnarchiveAudience: (value) =>
        set({ showUnarchiveAudience: value }, false, action('setShowUnarchiveAudience')),
      setTab: (value) => set({ tab: value }, false, action('setTab')),
    }))
  ),
  isEqual
);
